import React, { Component } from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';
import { getFormatMessageFunction } from '../../redux/modules/locale';
import { readMarkedProps, isTranslatable } from '../../translation/translation-utils';
export { markAsTranslatable as tr } from '../../translation/translation-utils';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
function mapStateToProps(state) {
    return {
        formatMessage: getFormatMessageFunction(state)
    };
}

const invalidStyle = { border: '1px solid var(--cancelColor)', background: '#d5486633' };

/* ============ PropsShifter ============ */
// eslint-disable-next-line no-restricted-syntax -- TODO: legacy class component (baseline)
class PropsFormatter extends Component {
    format(prop) {
        const { formatMessage } = this.props;
        if (typeof prop !== 'object' || prop === null) return prop;
        if (isTranslatable(prop)) return formatMessage(readMarkedProps(prop));

        if (prop instanceof Array) {
            return prop.map(value => this.format(value));
        }

        const formattedProps = {};
        Object.keys(prop).map(key => (formattedProps[key] = this.format(prop[key])));

        return formattedProps;
    }
    render() {
        const { children, formatMessage, dispatch, validationPredicate, ...params } = this.props;

        const formattedParams = this.format(params);
        const { value } = children.props;
        const invalid = validationPredicate && !validationPredicate(value);

        return React.cloneElement(React.Children.only(children), {
            ...formattedParams,
            style: { ...formattedParams.style, ...(invalid && invalidStyle) }
        });
    }
}

PropsFormatter = connect(mapStateToProps)(PropsFormatter);
export { PropsFormatter as default };
